module.exports = __webpack_public_path__ + "static/media/0.376db085.png";